export default __webpack_public_path__ + "static/media/user_placeholder.65f9347f.png";